import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/sos-logo.png'


const _hoisted_1 = {
  key: 0,
  class: "flex flex-row justify-between bg-primary relative z-10"
}
const _hoisted_2 = { class: "flex flex-row items-center h-16 justify-between w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo beepi",
  class: "object-contain"
}, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "hidden md:flex items-center h-full w-4/6 xl:w-2/5"
}
const _hoisted_5 = { class: "hidden md:flex w-full items-center justify-between gap-4 h-full" }
const _hoisted_6 = {
  key: 1,
  class: "hidden md:flex flex-row items-center justify-between gap-4 lg:gap-8"
}
const _hoisted_7 = {
  key: 0,
  class: "flex items-center relative"
}
const _hoisted_8 = { class: "flex flex-col w-full relative" }
const _hoisted_9 = { class: "py-2 px-4 text-white rounded-t-lg flex items-center justify-between" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-bold" }, "Notificaciones", -1)
const _hoisted_11 = {
  key: 0,
  class: "p-1"
}
const _hoisted_12 = { class: "mr-2" }
const _hoisted_13 = ["onChange"]
const _hoisted_14 = { class: "text-sm text-gray-800" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "bg-green-100 p-4 flex items-center gap-2 text-nowrap" }
const _hoisted_17 = {
  key: 1,
  class: "relative flex text-sm"
}
const _hoisted_18 = {
  key: 0,
  class: "absolute flex flex-col gap-4 p-4 rounded-b-md shadow-xl bg-primary right-0 top-10 sm:w-[300px] xl:w-[600px] z-[20]"
}
const _hoisted_19 = { class: "flex" }
const _hoisted_20 = {
  key: 0,
  class: "md:hidden flex flex-row items-center"
}
const _hoisted_21 = { class: "relative flex flex-row items-center justify-end" }
const _hoisted_22 = {
  key: 0,
  class: "flex flex-row items-center p-2"
}

import { ref, computed, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { AuthService } from "@/services/auth/AuthServices";
import { useAuthStore } from "@/stores/auth";

import { CommunityService } from "@/services/communities/CommunityServices";
import { NotificationBase } from "@/services/notifications/types";
import { NotificationServices } from "@/services/notifications/NotificationServices";

import { swal as Swal } from "@/configs/swal";
import Selector from "@/components/general/atoms/Selector.vue";

interface Community {
  value: any;
  label: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

const communityService = new CommunityService();
const notificationServices = new NotificationServices();

const loading = ref<boolean>(false);
const showNotifications = ref<boolean>(false);

const authService = new AuthService();
const router = useRouter();
const route = useRoute();
const hasError = ref<boolean>(false);
const authStore = useAuthStore();

const blockId = computed(() => {
  const id = Number(route.params.id)
  return isNaN(id) ? 0 : id
})
const communityId = computed(() => +route.params.community);
const buildingBlocks = ref<Community[]>([]);
const notifications = ref<NotificationBase[]>([]);
const menuOpen = ref<boolean>(false);
const checkNotification = ref<number[]>([]);

const showCommunitySelector = ref<boolean>(false);

const init = async () => {
  checkNotification.value = [];
  await obtainBlock();
  // Llamada a obtener notificaciones deshabilitada temporalmente
  // await obtainNotification();
};

const toggleMenu = () => {
  menuOpen.value = !menuOpen.value;
};

async function logout() {
  const result = await Swal.fire({
    icon: "warning",
    title: "Cerrar sesión",
    text: "¿Está seguro que desea cerrar sesión?",
    confirmButtonText: "Cerrar sesión",
    showCancelButton: true,
  });

  if (!result.isConfirmed) return;

  loading.value = true;
  const authToken = authStore.token as string;
  try {
    const response = await authService.logout(authToken);
    if (response.code == 204) {
      authStore.logout();
      router.push("/");
    }
  } catch (error) {
    console.error(error);
    hasError.value = true;
  } finally {
    loading.value = false;
  }
}

// Función de obtener notificaciones deshabilitada temporalmente
const obtainNotification = async () => {
  // const authToken = authStore.userSession;
  // if (authToken) {
  //     const { data } = await notificationServices.getNotificationUser(
  //         authToken?.userId
  //     );
  //     if (data)
  //         notifications.value = data.filter((item) => item.isActive === true);
  // }
  // Función vacía para mantener compatibilidad
};

const obtainBlock = async () => {
  const authToken = authStore.userSession;
  buildingBlocks.value = [];
  if (authToken) {
    //console.log("Hep: ", communityId.value);
    const response = await communityService.getComunityUser(
      communityId.value,
      authToken?.userId
    );

    if (response.success) {
      const responseBlocks = await communityService.getCommunityBlocks(
        response.data.communityId,
        response.data.id
      );

      if (responseBlocks.success) {
        if (responseBlocks.data.length > 0) {
          buildingBlocks.value = responseBlocks.data.map(
            (obj: { id: any; name: any }) => ({
              value: obj.id,
              label: obj.name,
            })
          );
        }
      }
    }
  }
};

const saveBlock = async (value: any) => {
  const newBlockId = parseInt(value);
  router.push({
    path: `/community/${communityId.value}/block/${newBlockId}/home`,
  });
  await init();
};

const saveNotification = async (id: number) => {
  const index = checkNotification.value.indexOf(id); // Buscar el índice del ID en el arreglo
  if (index !== -1) {
    checkNotification.value.splice(index, 1); // Eliminar el ID si se encuentra en el arreglo
  } else {
    checkNotification.value.push(id); // Agregar el ID al arreglo si no se encuentra
  }
};

const sendCheckNotification = async () => {
  const authToken = authStore.userSession;
  if (authToken) {
    const receivers = {
      receiver_ids: checkNotification.value,
      is_active: false,
    };
    await notificationServices.updateNotifications(
      authToken?.userId,
      receivers
    );

    await init();
  }
};

const hiddenNotification = async () => {
  showNotifications.value = !showNotifications.value;
  checkNotification.value = [];
};

watch(
  () => communityId.value,
  async () => {
    await init();
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_mdicon = _resolveComponent("mdicon")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (!_ctx.$route.path.includes('register'))
    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: { path: `/community/${_unref(communityId)}/block/${_unref(blockId)}/home` },
            class: "py-2 px-4 w-36"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["to"]),
          (_unref(blockId) != 0)
            ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
                _createElementVNode("nav", _hoisted_5, [
                  (_unref(blockId) != 0)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: { path: `/community/${_unref(communityId)}/block/${_unref(blockId)}/home` },
                        class: "text-center text-sm h-full font-normal xl:font-semibold text-white focus:outline-none focus:text-white hover:text-primary transition duration-150 ease-in-out"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: _normalizeClass([{ 'bg-white mt-1.5 ': _ctx.$route.path.includes('home') }, "flex hover:bg-white transition-all items-center h-full p-2 rounded-t-lg"])
                          }, [
                            _createElementVNode("p", {
                              class: _normalizeClass(["backdrop-filter whitespace-nowrap mx-2", {
                  'backdrop-blur-md text-success font-semibold':
                    _ctx.$route.path.includes('home'),
                }])
                            }, " Menú principal ", 2)
                          ], 2)
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true),
                  (_unref(blockId) != 0)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        to: { path: `/community/${_unref(communityId)}/block/${_unref(blockId)}/queries` },
                        class: "text-center text-sm h-full font-normal xl:font-semibold text-white focus:outline-none focus:text-white hover:text-primary transition duration-150 ease-in-out"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: _normalizeClass([{ 'bg-white mt-1.5': _ctx.$route.path.includes('queries') }, "flex hover:bg-white transition-all items-center h-full p-2 rounded-t-lg"])
                          }, [
                            _createElementVNode("p", {
                              class: _normalizeClass(["backdrop-filter mx-2", {
                  'backdrop-blur-md text-success font-semibold':
                    _ctx.$route.path.includes('queries'),
                }])
                            }, " Consultas ", 2)
                          ], 2)
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true),
                  (_unref(blockId) != 0)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 2,
                        to: {
              path: `/community/${_unref(communityId)}/block/${_unref(blockId)}/emergency`,
            },
                        class: "text-center text-sm h-full font-normal xl:font-semibold text-white focus:outline-none focus:text-white hover:text-primary transition duration-150 ease-in-out"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: _normalizeClass([{ 'bg-white mt-1.5 ': _ctx.$route.path.includes('/emergency') && !_ctx.$route.path.includes('emergency-plan') }, "flex hover:bg-white transition-all items-center h-full p-2 rounded-t-lg"])
                          }, [
                            _createElementVNode("p", {
                              class: _normalizeClass(["backdrop-filter mx-2", {
                  'backdrop-blur-md text-success font-semibold':
                    _ctx.$route.path.includes('/emergency') && !_ctx.$route.path.includes('emergency-plan'),
                }])
                            }, " Emergencias ", 2)
                          ], 2)
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_router_link, {
                    to: { path: `/community/${_unref(communityId)}/block/${_unref(blockId)}/events` },
                    class: "text-center text-sm h-full font-normal xl:font-semibold text-white focus:outline-none focus:text-white hover:text-primary transition duration-150 ease-in-out"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass([{ 'bg-white mt-1.5': _ctx.$route.path.includes('events') }, "flex hover:bg-white transition-all items-center h-full p-2 rounded-t-lg"])
                      }, [
                        _createElementVNode("p", {
                          class: _normalizeClass(["backdrop-filter mx-2", {
                  'backdrop-blur-md text-success font-semibold':
                    _ctx.$route.path.includes('events'),
                }])
                        }, " Eventos ", 2)
                      ], 2)
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createVNode(_component_router_link, {
                    to: {
              path: `/community/${_unref(communityId)}/block/${_unref(blockId)}/tutorial`,
            },
                    class: "text-center text-sm h-full font-normal xl:font-semibold text-white focus:outline-none focus:text-white hover:text-primary transition duration-150 ease-in-out"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass([{ 'bg-white mt-1.5': _ctx.$route.path.includes('tutorial') }, "flex hover:bg-white transition-all items-center h-full p-2 rounded-t-lg"])
                      }, [
                        _createElementVNode("p", {
                          class: _normalizeClass(["backdrop-filter mx-2", {
                  'backdrop-blur-md text-success font-semibold':
                    _ctx.$route.path.includes('tutorial'),
                }])
                        }, " Tutoriales ", 2)
                      ], 2)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(blockId) != 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                false
                  ? (_openBlock(), _createElementBlock("figure", _hoisted_7, [
                      _createVNode(_component_mdicon, {
                        class: "cursor-pointer text-white hover:scale-105 transition-all",
                        name: "bell-outline",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (hiddenNotification()))
                      }),
                      (notifications.value.length > 0)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (hiddenNotification())),
                            class: "cursor-pointer absolute top-0 right-0 bg-red-500 text-white rounded-full w-3.5 h-3.5 flex items-center justify-center text-xs"
                          }, _toDisplayString(notifications.value.length), 1))
                        : _createCommentVNode("", true),
                      (showNotifications.value)
                        ? _withDirectives((_openBlock(), _createElementBlock("header", {
                            key: 1,
                            class: _normalizeClass(["hidden md:flex absolute bg-primary rounded-b-lg shadow-lg w-64 right-0 mt-11 overflow-clip z-10", { 'top-0': showNotifications.value }])
                          }, [
                            _createElementVNode("article", _hoisted_8, [
                              _createElementVNode("section", _hoisted_9, [
                                _hoisted_10,
                                (checkNotification.value.length > 0)
                                  ? (_openBlock(), _createBlock(_component_mdicon, {
                                      key: 0,
                                      size: "30",
                                      class: "cursor-pointer font-semibold text-white hover:text-success focus:outline-none focus:text-white transition duration-150 ease-in-out",
                                      name: "send-circle",
                                      onClick: sendCheckNotification
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              (notifications.value.length > 0)
                                ? (_openBlock(), _createElementBlock("section", _hoisted_11, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notifications.value, (notification) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: notification.id,
                                        class: "bg-green-100 p-3 rounded-lg flex items-center"
                                      }, [
                                        _createElementVNode("div", _hoisted_12, [
                                          _createElementVNode("input", {
                                            type: "checkbox",
                                            onChange: ($event: any) => (saveNotification(notification.id)),
                                            class: "form-checkbox h-4 w-4 text-green-500"
                                          }, null, 40, _hoisted_13)
                                        ]),
                                        _createElementVNode("p", _hoisted_14, _toDisplayString(notification.description), 1)
                                      ]))
                                    }), 128))
                                  ]))
                                : (_openBlock(), _createElementBlock("section", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, [
                                      _createVNode(_component_mdicon, {
                                        class: "text-primary",
                                        name: "information-outline"
                                      }),
                                      _createTextVNode(" No se registran notificaciones ")
                                    ])
                                  ]))
                            ])
                          ], 2)), [
                            [_directive_click_outside, () => hiddenNotification()]
                          ])
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(blockId) !== 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("button", {
                        onClick: _cache[2] || (_cache[2] = () => (showCommunitySelector.value = !showCommunitySelector.value)),
                        class: "cursor-pointer text-white hover:scale-110 transition-all"
                      }, [
                        _createVNode(_component_mdicon, { name: "account-outline" })
                      ]),
                      (showCommunitySelector.value)
                        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createVNode(Selector, {
                              backGround: 'bg-white border-green-700 font-normal ',
                              borderColor: '',
                              selectedItem: _unref(blockId),
                              placeHolder: 'Seleccione un Block',
                              class: "gap-4",
                              onUpdate: saveBlock,
                              items: buildingBlocks.value
                            }, null, 8, ["selectedItem", "items"])
                          ])), [
                            [_directive_click_outside, () => (showCommunitySelector.value = false)]
                          ])
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (logout())),
                    class: "pr-4 text-sm font-semibold text-white focus:outline-none hover:scale-105 focus:text-white transition duration-150 ease-in-out"
                  }, [
                    _createVNode(_component_mdicon, { name: "logout" })
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_unref(blockId) != 0)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_mdicon, {
                  class: "cursor-pointer mx-4 text-white",
                  name: "microsoft-xbox-controller-menu",
                  size: "50",
                  onClick: toggleMenu
                }),
                _createElementVNode("header", {
                  class: _normalizeClass(["md:hidden flex flex-col absolute text-xl top-10 mt-4 w-64 ml-20 bg-primary rounded-b-lg overflow-clip shadow-lg", { hidden: !menuOpen.value }])
                }, [
                  _createVNode(_component_router_link, {
                    to: { path: `/community/${_unref(communityId)}/block/${_unref(blockId)}/home` },
                    class: _normalizeClass(["flex flex-row items-center p-2 font-semibold text-white hover:bg-white hover:text-primary focus:outline-none focus:text-white transition duration-150 ease-in-out w-full", {
              ' bg-white text-success': _ctx.$route.path.includes('home'),
            }]),
                    onClick: toggleMenu
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Menú Principal ")
                    ]),
                    _: 1
                  }, 8, ["to", "class"]),
                  _createVNode(_component_router_link, {
                    to: { path: `/community/${_unref(communityId)}/block/${_unref(blockId)}/queries` },
                    class: _normalizeClass(["flex flex-row items-center p-2 font-semibold text-white hover:bg-white hover:text-primary focus:outline-none focus:text-white transition duration-150 ease-in-out w-full", {
              ' bg-white text-success': _ctx.$route.path.includes('queries'),
            }]),
                    onClick: toggleMenu
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Consultas ")
                    ]),
                    _: 1
                  }, 8, ["to", "class"]),
                  _createVNode(_component_router_link, {
                    to: {
              path: `/community/${_unref(communityId)}/block/${_unref(blockId)}/emergency`,
            },
                    class: _normalizeClass(["flex flex-row items-center p-2 font-semibold text-white hover:bg-white hover:text-primary focus:outline-none focus:text-white transition duration-150 ease-in-out w-full", {
              ' bg-white text-success': _ctx.$route.path.includes('/emergency') && !_ctx.$route.path.includes('emergency-plan'),
            }]),
                    onClick: toggleMenu
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Emergencia ")
                    ]),
                    _: 1
                  }, 8, ["to", "class"]),
                  _createVNode(_component_router_link, {
                    to: { path: `/community/${_unref(communityId)}/block/${_unref(blockId)}/events` },
                    class: _normalizeClass(["flex flex-row items-center p-2 font-semibold text-white hover:bg-white hover:text-primary focus:outline-none focus:text-white transition duration-150 ease-in-out w-full", {
              ' bg-white text-success': _ctx.$route.path.includes('events'),
            }]),
                    onClick: toggleMenu
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Eventos ")
                    ]),
                    _: 1
                  }, 8, ["to", "class"]),
                  _createVNode(_component_router_link, {
                    to: {
              path: `/community/${_unref(communityId)}/block/${_unref(blockId)}/tutorial`,
            },
                    class: _normalizeClass(["flex flex-row items-center p-2 font-semibold text-white hover:bg-white hover:text-primary focus:outline-none focus:text-white transition duration-150 ease-in-out w-full", {
              ' bg-white text-success': _ctx.$route.path.includes('tutorial'),
            }]),
                    onClick: toggleMenu
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Tutoriales ")
                    ]),
                    _: 1
                  }, 8, ["to", "class"]),
                  (_unref(blockId) != 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createVNode(Selector, {
                          backGround: 'bg-primary border-green-700 font-semibold text-white',
                          borderColor: '',
                          selectedItem: _unref(blockId),
                          placeHolder: 'Seleccione un Block',
                          class: "gap-4",
                          onUpdate: saveBlock,
                          items: buildingBlocks.value
                        }, null, 8, ["selectedItem", "items"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", { class: "flex" }, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: logout,
                      class: "flex flex-row items-center p-2 font-semibold text-white hover:bg-white hover:text-primary focus:outline-none focus:text-white transition duration-150 ease-in-out w-full"
                    }, " Cerrar Sesión ")
                  ])
                ], 2)
              ])
            ])), [
              [_directive_click_outside, () => (menuOpen.value = false)]
            ])
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})